<template>
  <v-container class="bg-white box-shadow rounded">
    <v-row>
      <v-col lg="7">
        <div class="filed mt-3">
          <span class="title">Name</span>
          <div class="input-container">
            <input type="text" v-model="ad_name" placeholder="Name Your ad" />
          </div>
          <div class="warning">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#444546"
              xmlns="http://www.w3.org/2000/svg"
              class="warning-svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
              ></path>
            </svg>
            <p class="small-text muted-text">Name is required.</p>
          </div>
        </div>
        <div class="filed mt-3">
          <span class="title">Public Profile</span>
          <div class="profile-pic d-flex align-center ga-3">
            <div class="pic">
              <img :src="public_profile_id?.image" alt="" />
            </div>
            <div class="name d-flex flex-column ga-1">
              <div class="">{{ public_profile_id?.name }}</div>
              <!-- <div class="small-text muted-text">Helmy</div> -->
            </div>
          </div>
        </div>
        <div class="filed mt-3">
          <span class="title">Brand Name * </span>
          <input
            type="text"
            v-model="brand_name"
            placeholder="Replace Profile Name"
          />
        </div>
        <div class="filed mt-3">
          <span class="title">Headline</span>
          <div class="input-container">
            <input type="text" v-model="headline" placeholder="Name Your ad" />
          </div>
          <div class="warning">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#444546"
              xmlns="http://www.w3.org/2000/svg"
              class="warning-svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
              ></path>
            </svg>
            <p class="small-text muted-text">headline is required.</p>
          </div>
        </div>
        <span
          v-if="offer_details_ad_disclaimer_ratio"
          class="radio-small"
          @click="offer_details_ad_disclaimer_ratio = false"
          >Remove Offer Details / Ad Disclaimer</span
        >
        <span
          v-else
          class="radio-small"
          @click="offer_details_ad_disclaimer_ratio = true"
          >Add Offer Details / Ad Disclaimer</span
        >
        <div v-if="offer_details_ad_disclaimer_ratio" class="filed mt-3">
          <span class="title">Offer Details / Ad Disclaimer </span>
          <div class="input-container">
            <input
              type="text"
              v-model="offer_details_ad_disclaimer"
              placeholder="Offer details / Ad Disclaimer"
            />
          </div>
          <div class="warning">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#444546"
              xmlns="http://www.w3.org/2000/svg"
              class="warning-svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
              ></path>
            </svg>
            <p class="small-text muted-text">
              Offer Details / Ad Disclaimer is required.
            </p>
          </div>
        </div>
        <div class="filed mt-3">
          <span class="title">Shareable</span>
          <div class="mt-3">
            <SwitchToogle
              @click="ToggleShareable"
              v-model:checked="shareable"
              :notAttached="false"
              :paused="false"
              :disabled="false"
            />
          </div>
        </div>
        <div class="filed mt-3">
          <span class="title">Topsnap Media *</span>
          <div class="mt-3">
            <UploadMedia
              :aspectRatio="9 / 16"
              :minAspectRatio="9 / 16"
              :maxAspectRatio="9 / 16"
              :cropWidth="1080"
              :cropHeight="1920"
              :minCropWidth="1080"
              :minCropHeight="1920"
              :size="5"
              @uploaded:id="uploadFile"
              @uploaded:url="(url) => (image_url = url)"
              @uploaded:video="(url) => (video_url = url)"
              @uploaded:delete="deleteFile('single_image_or_video_tosnap_file')"
              :old_id="single_image_or_video_tosnap_file"
              :type="'all'"
            />
          </div>
        </div>
        <div class="filed mt-3">
          <span class="title">Post to Public Profile</span>
          <div class="d-flex ga-3 mt-3">
            <SwitchToogle
              @click="TogglePostToPublicProfile"
              v-model:checked="post_to_public"
              :notAttached="false"
              :paused="false"
              :disabled="false"
              :is_status_print="false"
            />
            <span v-if="!post_to_public" class="text-subtitle-2"
              >Post uploaded media to your Public Story and Profile for greater
              organic reach!</span
            >
            <span v-if="post_to_public" class="text-subtitle-2"
              >Your uploaded media will appear on your Public Story and Profile
              once you publish your ad!</span
            >
          </div>
        </div>
        <div class="filed mt-3">
          <div class="title">Attachment</div>
          <v-select
            v-if="selectedCampaign !== 'Leads'"
            variant="solo"
            class="v-select-style"
            v-model="selected_ad_type"
            :items="getAdTypes"
            item-title="name"
            item-value="value"
          ></v-select>
          <div v-else>{{ direct_traffic_location }}</div>
        </div>
        <div v-if="selected_ad_type === 'AD_TO_MESSAGE'" class="">
          <div class="filed mt-3">
            <div class="title">Call To Action</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="call_to_action"
                :items="ad_to_message_ctas"
                item-title="title"
                item-value="value"
              ></v-select>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Ad Favoriting</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleAdFavoriting"
                v-model:checked="ad_favoriting"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Switch to Standard Button Color</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStandardButtonColor"
                v-model:checked="standard_button_color"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Optional Text Message</span>
            <div class="input-container">
              <input
                type="text"
                v-model="optional_text_message"
                placeholder="Optional Text Message"
              />
            </div>
          </div>
        </div>
        <div v-if="selected_ad_type === 'AD_TO_CALL'" class="">
          <div class="filed mt-3">
            <div class="title">Call To Action</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="call_to_action"
                :items="ad_to_call_ctas"
                item-title="title"
                item-value="value"
                disabled
              ></v-select>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Ad Favoriting</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleAdFavoriting"
                v-model:checked="ad_favoriting"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Switch to Standard Button Color</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStandardButtonColor"
                v-model:checked="standard_button_color"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
        </div>
        <div v-if="selected_ad_type === 'DEEP_LINK'" class="">
          <div class="filed mt-3">
            <div class="title">Call To Action</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="call_to_action"
                :items="deep_link_ctas"
                item-title="title"
                item-value="value"
              ></v-select>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Ad Favoriting</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleAdFavoriting"
                v-model:checked="ad_favoriting"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Switch to Standard Button Color</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStandardButtonColor"
                v-model:checked="standard_button_color"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">App Name</span>
            <div class="input-container">
              <input
                type="text"
                v-model="app_name"
                placeholder="Name Your Website URL"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Deeplink Uri </span>
            <div class="input-container">
              <input
                type="text"
                v-model="deep_link_uri"
                placeholder="Deeplink Uri"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">iOS App ID</span>
            <div class="input-container">
              <input
                type="text"
                v-model="ios_app_id"
                placeholder="iOS App ID"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Android App Url</span>
            <div class="input-container">
              <input
                type="text"
                v-model="android_app_url"
                placeholder="Android App URL"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Fallback Type</span>
            <div class="input-container">
              <div class="">
                <button
                  class="app-install-button"
                  :style="getButtonStyle('app_install')"
                  @click="fallback_type = 'app_install'"
                >
                  App Install
                </button>
                <button
                  class="web-site-button"
                  :style="getButtonStyle('web_site')"
                  @click="fallback_type = 'web_site'"
                >
                  Web Site
                </button>
              </div>
            </div>
          </div>
          <div class="" v-if="fallback_type === 'app_install'">
            <div class="filed mt-3">
              <span class="title">Use Custom iOS Product Page</span>
              <div class="mt-3">
                <SwitchToogle
                  @click="ToggleCustomIosProductPage"
                  v-model:checked="custom_ios_product_page"
                  :notAttached="false"
                  :paused="false"
                  :disabled="false"
                />
              </div>
            </div>
            <div v-if="custom_ios_product_page" class="filed mt-3">
              <span class="title">Custom Product Page ID</span>
              <div class="input-container">
                <input
                  type="text"
                  v-model="custom_ios_product_page_id"
                  placeholder="Custom Product Page ID"
                />
              </div>
            </div>
          </div>
          <div class="" v-if="fallback_type === 'web_site'">
            <div class="filed mt-3">
              <span class="title">Web Site URL </span>
              <div class="input-container">
                <input
                  type="text"
                  v-model="fallback_website_url"
                  placeholder="Web Site URL"
                />
              </div>
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">App Icon</span>
            <div class="mt-3">
              <div class="" v-if="image_app_icon_url != ''">
                <div class="d-flex ga-2">
                  <img
                    :src="image_app_icon_url"
                    width="48"
                    height="80"
                    style="border-radius: 10px"
                    alt=""
                  />
                  <span class="delete-image" @click="image_app_icon_url = ''">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <title>delete</title>
                      <g
                        id="Icon/SDS/Trash"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <path
                          d="M11,14 L12,14 L12,5 L11,5 L11,14 Z M7.5,14 L8.5,14 L8.5,5 L7.5,5 L7.5,14 Z M4,14 L5,14 L5,5 L4,5 L4,14 Z M14,3 C14.553,3 15,3.448 15,4 C15,4.552 14.553,5 14,5 L14,14 C14,15.104 13.104,16 12,16 L4,16 C2.896,16 2,15.104 2,14 L2,5 C1.448,5 1,4.552 1,4 C1,3.448 1.448,3 2,3 L14,3 Z M3,2 C2.448,2 2,1.552 2,1 C2,0.448 2.448,0 3,0 L13,0 C13.553,0 14,0.448 14,1 C14,1.552 13.553,2 13,2 L3,2 Z"
                          id="🎨-Fill-Color"
                          fill="#16191C"
                        ></path>
                      </g>
                    </svg>
                  </span>
                </div>
              </div>
              <UploadMedia
                :aspectRatio="1 / 1"
                :minAspectRatio="1 / 1"
                :maxAspectRatio="1 / 1"
                :maxCropWidth="2000"
                :maxCropHeight="2000"
                :minCropWidth="200"
                :minCropHeight="200"
                @uploaded:id="uploadimageAppIconFile"
                @uploaded:delete="deleteFile('image_app_icon_file')"
                :old_id="image_app_icon_file"
                v-else
              />
            </div>
          </div>
        </div>
        <div v-if="selected_ad_type === 'APP_INSTALL'" class="">
          <div class="filed mt-3">
            <div class="title">Call To Action</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="call_to_action"
                :items="app_install_ctas"
                item-title="title"
                item-value="value"
              ></v-select>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Ad Favoriting</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleAdFavoriting"
                v-model:checked="ad_favoriting"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Switch to Standard Button Color</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStandardButtonColor"
                v-model:checked="standard_button_color"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">App Name</span>
            <div class="input-container">
              <input
                type="text"
                v-model="app_name"
                placeholder="Name Your Website URL"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">iOS App ID</span>
            <div class="input-container">
              <input
                type="text"
                v-model="ios_app_id"
                placeholder="iOS App ID"
              />
            </div>
          </div>
          <div>
            <div class="filed mt-3">
              <span class="title">Use Custom iOS Product Page</span>
              <div class="mt-3">
                <SwitchToogle
                  @click="ToggleCustomIosProductPage"
                  v-model:checked="custom_ios_product_page"
                  :notAttached="false"
                  :paused="false"
                  :disabled="false"
                />
              </div>
            </div>
            <div v-if="custom_ios_product_page" class="filed mt-3">
              <span class="title">Custom Product Page ID</span>
              <div class="input-container">
                <input
                  type="text"
                  v-model="custom_ios_product_page_id"
                  placeholder="Custom Product Page ID"
                />
              </div>
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Android App Url</span>
            <div class="input-container">
              <input
                type="text"
                v-model="android_app_url"
                placeholder="Android App URL"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">App Icon</span>
            <div class="mt-3">
              <div class="" v-if="image_app_icon_url != ''">
                <div class="d-flex ga-2">
                  <img
                    :src="image_app_icon_url"
                    width="48"
                    height="80"
                    style="border-radius: 10px"
                    alt=""
                  />
                  <span class="delete-image" @click="image_app_icon_url = ''">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <title>delete</title>
                      <g
                        id="Icon/SDS/Trash"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <path
                          d="M11,14 L12,14 L12,5 L11,5 L11,14 Z M7.5,14 L8.5,14 L8.5,5 L7.5,5 L7.5,14 Z M4,14 L5,14 L5,5 L4,5 L4,14 Z M14,3 C14.553,3 15,3.448 15,4 C15,4.552 14.553,5 14,5 L14,14 C14,15.104 13.104,16 12,16 L4,16 C2.896,16 2,15.104 2,14 L2,5 C1.448,5 1,4.552 1,4 C1,3.448 1.448,3 2,3 L14,3 Z M3,2 C2.448,2 2,1.552 2,1 C2,0.448 2.448,0 3,0 L13,0 C13.553,0 14,0.448 14,1 C14,1.552 13.553,2 13,2 L3,2 Z"
                          id="🎨-Fill-Color"
                          fill="#16191C"
                        ></path>
                      </g>
                    </svg>
                  </span>
                </div>
              </div>
              <UploadMedia
                :aspectRatio="1 / 1"
                :minAspectRatio="1 / 1"
                :maxAspectRatio="1 / 1"
                :maxCropWidth="2000"
                :maxCropHeight="2000"
                :minCropWidth="200"
                :minCropHeight="200"
                @uploaded:id="uploadimageAppIconFile"
                @uploaded:delete="deleteFile('image_app_icon_file')"
                :old_id="image_app_icon_file"
                v-else
              />
            </div>
          </div>
        </div>
        <div v-if="selected_ad_type === 'WEB_VIEW'" class="">
          <div class="filed mt-3">
            <div class="title">Call To Action</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="call_to_action"
                :items="web_view_call_to_action_items"
                item-title="title"
                item-value="value"
              ></v-select>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Ad Favoriting</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleAdFavoriting"
                v-model:checked="ad_favoriting"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Switch to Standard Button Color</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStandardButtonColor"
                v-model:checked="standard_button_color"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Website URL</span>
            <div class="input-container">
              <input
                type="text"
                v-model="website_url"
                placeholder="Name Your Website URL"
              />
            </div>
            <div class="warning">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#444546"
                xmlns="http://www.w3.org/2000/svg"
                class="warning-svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
                ></path>
              </svg>
              <p class="small-text muted-text">Website URL is required.</p>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Smart Prefetching</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleSmartPerefetching"
                v-model:checked="smart_prefetching"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
        </div>
        <div v-if="selectedCampaign === 'Leads'" class="">
          <div class="filed mt-3">
            <div class="title">Call To Action</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="call_to_action"
                :items="leads_call_to_action_items"
                item-title="title"
                item-value="value"
              ></v-select>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Ad Favoriting</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleAdFavoriting"
                v-model:checked="ad_favoriting"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="title">Switch to Standard Button Color</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStandardButtonColor"
                v-model:checked="standard_button_color"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
        </div>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col lg="5">
        <div class="">
          <div class="filed mt-3">
            <div class="title">Placement Preview</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="placement_review"
                :items="[
                  { title: 'Stories', value: 'stories' },
                  { title: 'Spotlight', value: 'spotlight' },
                ]"
                item-title="title"
                item-value="value"
              ></v-select>
            </div>
          </div>
          <div class="mt-3 d-flex justify-center">
            <div
              @mouseenter="playVideo"
              @mouseleave="pauseVideo"
              v-if="placement_review == 'stories'"
              class="data-review"
            >
              <div class="header">
                <svg viewBox="0 0 394 49" xmlns="http://www.w3.org/2000/svg">
                  <rect transform="translate(0.5 0.753906)" fill="black"></rect>
                  <path
                    opacity="0.5"
                    d="M365.281 24.7539V28.7847C365.892 28.4433 366.289 27.6491 366.289 26.7693C366.289 25.8894 365.892 25.0953 365.281 24.7539Z"
                    fill="#ECECEE"
                  ></path>
                  <rect
                    opacity="0.5"
                    x="339.586"
                    y="21.2265"
                    width="24.1846"
                    height="11.0846"
                    rx="3.52692"
                    stroke="#ECECEE"
                    stroke-width="1.00769"
                  ></rect>
                  <rect
                    x="341.098"
                    y="22.7383"
                    width="21.1615"
                    height="8.06154"
                    rx="2.01538"
                    fill="#ECECEE"
                  ></rect>
                  <path
                    d="M323.464 23.234C325.95 23.2341 328.34 24.173 330.142 25.8567C330.277 25.9867 330.494 25.985 330.628 25.853L331.924 24.5665C331.992 24.4995 332.03 24.4088 332.029 24.3144C332.029 24.2201 331.99 24.1298 331.921 24.0636C327.193 19.609 319.734 19.609 315.006 24.0636C314.938 24.1298 314.899 24.22 314.898 24.3144C314.898 24.4087 314.935 24.4995 315.003 24.5665L316.3 25.853C316.434 25.9852 316.651 25.9869 316.786 25.8567C318.588 24.1729 320.979 23.234 323.464 23.234ZM323.464 27.4197C324.83 27.4196 326.147 27.9186 327.159 28.8198C327.296 28.9477 327.512 28.9449 327.645 28.8135L328.94 27.527C329.009 27.4595 329.046 27.368 329.045 27.2728C329.044 27.1777 329.005 27.0869 328.935 27.0208C325.853 24.2018 321.079 24.2018 317.996 27.0208C317.926 27.0869 317.887 27.1778 317.886 27.2729C317.885 27.3681 317.923 27.4596 317.991 27.527L319.286 28.8135C319.419 28.9449 319.635 28.9477 319.772 28.8198C320.784 27.9192 322.1 27.4202 323.464 27.4197ZM325.953 30.4901C326.023 30.4233 326.061 30.3313 326.059 30.2359C326.057 30.1405 326.015 30.0501 325.943 29.9861C324.512 28.7964 322.417 28.7964 320.986 29.9861C320.914 30.0501 320.872 30.1404 320.87 30.2358C320.868 30.3312 320.906 30.4232 320.975 30.4901L323.216 32.7129C323.281 32.7782 323.371 32.815 323.464 32.815C323.558 32.815 323.647 32.7782 323.713 32.7129L325.953 30.4901Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M288.877 28.2803H290.062C290.717 28.2803 291.248 28.7879 291.248 29.414V31.6813C291.248 32.3074 290.717 32.815 290.062 32.815H288.877C288.222 32.815 287.691 32.3074 287.691 31.6813V29.414C287.691 28.7879 288.222 28.2803 288.877 28.2803ZM294.409 26.013H295.595C296.25 26.013 296.78 26.5206 296.78 27.1467V31.6813C296.78 32.3074 296.25 32.815 295.595 32.815H294.409C293.755 32.815 293.224 32.3074 293.224 31.6813V27.1467C293.224 26.5206 293.755 26.013 294.409 26.013ZM299.942 23.3678H301.127C301.782 23.3678 302.313 23.8754 302.313 24.5015V31.6813C302.313 32.3074 301.782 32.815 301.127 32.815H299.942C299.287 32.815 298.756 32.3074 298.756 31.6813V24.5015C298.756 23.8754 299.287 23.3678 299.942 23.3678ZM305.474 20.7227H306.66C307.314 20.7227 307.845 21.2302 307.845 21.8563V31.6813C307.845 32.3074 307.314 32.815 306.66 32.815H305.474C304.819 32.815 304.289 32.3074 304.289 31.6813V21.8563C304.289 21.2302 304.819 20.7227 305.474 20.7227Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M47.44 32.7227V22.8273H47.2978L44.2949 24.9352V22.8608L47.4484 20.6525H49.5981V32.7227H47.44ZM55.9385 32.7227V22.8273H55.7963L52.7934 24.9352V22.8608L55.9469 20.6525H58.0966V32.7227H55.9385ZM63.0819 31.0581C62.2956 31.0581 61.7435 30.4893 61.7435 29.7365C61.7435 28.9753 62.2956 28.4149 63.0819 28.4149C63.8765 28.4149 64.4202 28.9753 64.4202 29.7365C64.4202 30.4893 63.8765 31.0581 63.0819 31.0581ZM63.0819 24.9519C62.2956 24.9519 61.7435 24.3915 61.7435 23.6387C61.7435 22.8775 62.2956 22.3171 63.0819 22.3171C63.8765 22.3171 64.4202 22.8775 64.4202 23.6387C64.4202 24.3915 63.8765 24.9519 63.0819 24.9519ZM71.5134 33.0238C68.6193 33.0238 66.9045 30.6817 66.9045 26.675C66.9045 22.6851 68.6444 20.3514 71.5134 20.3514C74.3741 20.3514 76.114 22.6851 76.114 26.6918C76.114 30.6817 74.3992 33.0238 71.5134 33.0238ZM71.5134 31.2338C73.0442 31.2338 73.9308 29.6696 73.9308 26.675C73.9308 23.6972 73.0274 22.1498 71.5134 22.1498C69.9994 22.1498 69.0877 23.7056 69.0877 26.675C69.0877 29.6696 69.9827 31.2338 71.5134 31.2338ZM84.0688 32.7227V30.4224H78.1717V28.624C79.7359 25.8971 81.4506 23.1452 83.0901 20.6525H86.1348V28.5989H87.7659V30.4224H86.1348V32.7227H84.0688ZM80.1708 28.532V28.6491H84.1022V22.4091H83.9851C82.7471 24.2827 81.3502 26.4994 80.1708 28.532Z"
                    fill="#ECECEE"
                  ></path>
                </svg>
              </div>
              <div
                class="body d-flex align-center justify-space-between flex-column position-relative"
              >
                <div
                  class="top d-flex justify-space-between align-center w-100 px-2"
                >
                  <div class="img-name d-flex align-center ga-2">
                    <img
                      width="28"
                      src="https://cf-st.sc-cdn.net/d/YmmIFdcbee3keYymYPlJq?bo=Eg0aABoAMgEESAJQCGAB&uc=8"
                      alt=""
                    />
                    <span class="text-body-2"
                      ><span class="font-weight-bold">{{ brand_name }}</span
                      >. <br />
                      {{ headline }}</span
                    >
                    <div class="text-caption">Ad</div>
                  </div>
                  <div class="">
                    <svg
                      class="styles-yedxbn"
                      width="108"
                      height="108"
                      viewBox="0 0 108 108"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter-more)">
                        <g filter="url(#filter1_d_101_2377)">
                          <path
                            d="M46.5 36C46.5 40.1421 49.8579 43.5 54 43.5C58.1421 43.5 61.5 40.1421 61.5 36C61.5 31.8579 58.1421 28.5 54 28.5C49.8579 28.5 46.5 31.8579 46.5 36Z"
                            fill="white"
                          ></path>
                          <path
                            d="M46.5 57C46.5 61.1421 49.8579 64.5 54 64.5C58.1421 64.5 61.5 61.1421 61.5 57C61.5 52.8579 58.1421 49.5 54 49.5C49.8579 49.5 46.5 52.8579 46.5 57Z"
                            fill="white"
                          ></path>
                          <path
                            d="M54 85.5C49.8579 85.5 46.5 82.1421 46.5 78C46.5 73.8579 49.8579 70.5 54 70.5C58.1421 70.5 61.5 73.8579 61.5 78C61.5 82.1421 58.1421 85.5 54 85.5Z"
                            fill="white"
                          ></path>
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="#filter-more"
                          x="-120"
                          y="-120"
                          width="348"
                          height="348"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          ></feFlood>
                          <feGaussianBlur
                            in="BackgroundImageFix"
                            stdDeviation="60"
                          ></feGaussianBlur>
                          <feComposite
                            in2="SourceAlpha"
                            operator="in"
                            result="effect1_backgroundBlur_101_2377"
                          ></feComposite>
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_backgroundBlur_101_2377"
                            result="shape"
                          ></feBlend>
                        </filter>
                        <filter
                          id="filter1_d_101_2377"
                          x="42.5"
                          y="25.5"
                          width="23"
                          height="65"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          ></feFlood>
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          ></feColorMatrix>
                          <feOffset dy="1"></feOffset>
                          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                          ></feColorMatrix>
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_101_2377"
                          ></feBlend>
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_101_2377"
                            result="shape"
                          ></feBlend>
                        </filter>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div
                  class="data"
                  :style="
                    image_url ? { backgroundImage: `url(${image_url})` } : ''
                  "
                >
                  <div v-if="!image_url && video_url" class="video-data">
                    <video muted loop id="myVideo">
                      <source :src="video_url" type="video/mp4" />
                    </video>
                  </div>

                  <div class="bottom">
                    <div class="see-details">
                      <svg
                        class="styles-1o01xn9"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7 12.425C9.99615 12.425 12.425 9.99615 12.425 7C12.425 4.00386 9.99615 1.575 7 1.575C4.00386 1.575 1.575 4.00386 1.575 7C1.575 9.99615 4.00386 12.425 7 12.425ZM7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
                          fill="currentColor"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7 10.9375C7.43492 10.9375 7.7875 10.585 7.7875 10.15V7.00003C7.7875 6.56511 7.43492 6.21253 7 6.21253C6.56508 6.21253 6.2125 6.56511 6.2125 7.00003V10.15C6.2125 10.585 6.56508 10.9375 7 10.9375Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M7.78746 4.46253C7.78746 4.02761 7.43488 3.67503 6.99996 3.67503C6.56503 3.67503 6.21246 4.02761 6.21246 4.46253C6.21246 4.89746 6.56503 5.25003 6.99996 5.25003C7.43488 5.25003 7.78746 4.89746 7.78746 4.46253Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                      <span>See Offer Details</span>
                    </div>
                    <div class="profile-favoriting">
                      <div
                        class="profile-favoriting-data d-flex align-center justify-space-between"
                      >
                        <div class="profile d-flex align-center ga-3">
                          <div class="img">
                            <img
                              width="35"
                              src="https://cf-st.sc-cdn.net/d/YmmIFdcbee3keYymYPlJq?bo=Eg0aABoAMgEESAJQCGAB&uc=8"
                              alt=""
                            />
                          </div>
                          <div class="name">
                            <span class="font-weight-bold">{{
                              brand_name
                            }}</span>
                            <br />
                            {{ headline }}
                          </div>
                        </div>
                        <svg
                          class="styles-1dxk6ak"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.4857 12L7.83276 17.6529L9.24698 19.0671L16.3141 12L9.24698 4.93289L7.83276 6.34711L13.4857 12Z"
                          ></path>
                        </svg>
                      </div>
                      <div class="profile-favoriting-favoriting">
                        <div v-if="ad_favoriting" class="svg">
                          <svg
                            width="48"
                            height="48"
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="styles-5mtvke"
                          >
                            <g clip-path="url(#clip)">
                              <g filter="url(#filter-heart)">
                                <path
                                  d="M24 15.1088C32.4677 4.43472 44.9916 15.6853 37.9154 26.6395C35.7984 30.8893 29.0331 36.0287 25.347 38.6643C24.9434 38.9465 24.4766 39.0963 24 39.0963C23.5233 39.0963 23.0563 38.9465 22.6528 38.6643C18.8926 36.0287 12.2013 30.8893 10.0844 26.6395C2.99341 15.6853 15.5914 4.43472 24 15.1088Z"
                                  fill="white"
                                ></path>
                                <path
                                  d="M25.6336 39.074L25.6336 39.0741L25.6378 39.071C27.4865 37.7492 30.1156 35.7937 32.5516 33.6311C34.9651 31.4884 37.2414 29.0975 38.3504 26.8875C41.9976 21.2197 40.6125 15.4001 37.113 12.3848C35.3639 10.8776 33.0877 10.0769 30.6811 10.3706C28.4155 10.6471 26.0857 11.8866 24.0013 14.3211C21.9299 11.8866 19.6058 10.6471 17.3418 10.3706C14.9367 10.0769 12.6575 10.8776 10.904 12.3843C7.39559 15.3989 5.994 21.2187 9.6495 26.8877C10.7579 29.0965 13.0144 31.4869 15.4197 33.6305C17.847 35.7937 20.4769 37.7498 22.3658 39.0737L22.3662 39.074C22.8508 39.413 23.4173 39.5963 24 39.5963C24.5827 39.5963 25.149 39.4129 25.6336 39.074Z"
                                  stroke="black"
                                  stroke-opacity="0.05"
                                  stroke-miterlimit="10"
                                ></path>
                              </g>
                            </g>
                            <defs>
                              <filter
                                id="filter-heart"
                                x="-2"
                                y="-1.18945"
                                width="52"
                                height="52"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                ></feFlood>
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                ></feColorMatrix>
                                <feOffset></feOffset>
                                <feGaussianBlur
                                  stdDeviation="4"
                                ></feGaussianBlur>
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                ></feColorMatrix>
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_3_13290"
                                ></feBlend>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_3_13290"
                                  result="shape"
                                ></feBlend>
                              </filter>
                              <clipPath id="clip">
                                <rect
                                  width="48"
                                  height="48"
                                  fill="white"
                                  transform="translate(0 0.810547)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div v-else class="ad-text">ad</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="standard-button d-flex align-center ga-2">
                <span
                  :class="
                    standard_button_color ? 'button standard-color' : ' button'
                  "
                  >{{ call_to_action }}</span
                >
                <span class="share">
                  <svg
                    class="share-svg"
                    width="156"
                    height="156"
                    viewBox="0 0 156 156"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter-go)">
                      <path
                        d="M82.3862 39.7208L118.027 69.4408L117.987 69.4008C120.504 71.5208 121.982 74.6408 121.982 77.9608C121.982 81.2808 120.544 84.4008 117.987 86.5208L82.3862 116.201C80.9878 117.361 79.3096 117.961 77.5915 117.961C76.5127 117.961 75.4339 117.721 74.395 117.241C71.758 116.001 70.0798 113.401 70.0798 110.441V94.0408C62.0487 94.3208 50.4215 96.2008 41.3116 108.361C40.3127 109.681 38.6346 110.241 37.0363 109.801C35.4381 109.361 34.2794 108.001 34.1196 106.361C34.0396 105.561 32.2816 86.6008 44.0686 73.6008C50.3416 66.6808 59.052 62.8008 70.0798 62.0808V45.4808C70.0798 42.5208 71.718 39.9208 74.395 38.6808C77.0721 37.4408 80.1087 37.8408 82.3862 39.7208Z"
                        fill="white"
                      ></path>
                    </g>
                    <defs>
                      <filter
                        id="filter-go"
                        x="6"
                        y="12"
                        width="144"
                        height="144"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        ></feFlood>
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        ></feColorMatrix>
                        <feOffset dy="6"></feOffset>
                        <feGaussianBlur stdDeviation="12"></feGaussianBlur>
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                        ></feColorMatrix>
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_108_1540"
                        ></feBlend>
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_108_1540"
                          result="shape"
                        ></feBlend>
                      </filter>
                    </defs>
                  </svg>
                </span>
              </div>
              <div class="footer-data d-flex justify-center align-center">
                <div class="mobile-button"></div>
              </div>
            </div>
            <div
              @mouseenter="playVideo"
              @mouseleave="pauseVideo"
              v-if="placement_review == 'spotlight'"
              class="data-review spotlight-review"
            >
              <div class="header">
                <svg viewBox="0 0 394 49" xmlns="http://www.w3.org/2000/svg">
                  <rect transform="translate(0.5 0.753906)" fill="black"></rect>
                  <path
                    opacity="0.5"
                    d="M365.281 24.7539V28.7847C365.892 28.4433 366.289 27.6491 366.289 26.7693C366.289 25.8894 365.892 25.0953 365.281 24.7539Z"
                    fill="#ECECEE"
                  ></path>
                  <rect
                    opacity="0.5"
                    x="339.586"
                    y="21.2265"
                    width="24.1846"
                    height="11.0846"
                    rx="3.52692"
                    stroke="#ECECEE"
                    stroke-width="1.00769"
                  ></rect>
                  <rect
                    x="341.098"
                    y="22.7383"
                    width="21.1615"
                    height="8.06154"
                    rx="2.01538"
                    fill="#ECECEE"
                  ></rect>
                  <path
                    d="M323.464 23.234C325.95 23.2341 328.34 24.173 330.142 25.8567C330.277 25.9867 330.494 25.985 330.628 25.853L331.924 24.5665C331.992 24.4995 332.03 24.4088 332.029 24.3144C332.029 24.2201 331.99 24.1298 331.921 24.0636C327.193 19.609 319.734 19.609 315.006 24.0636C314.938 24.1298 314.899 24.22 314.898 24.3144C314.898 24.4087 314.935 24.4995 315.003 24.5665L316.3 25.853C316.434 25.9852 316.651 25.9869 316.786 25.8567C318.588 24.1729 320.979 23.234 323.464 23.234ZM323.464 27.4197C324.83 27.4196 326.147 27.9186 327.159 28.8198C327.296 28.9477 327.512 28.9449 327.645 28.8135L328.94 27.527C329.009 27.4595 329.046 27.368 329.045 27.2728C329.044 27.1777 329.005 27.0869 328.935 27.0208C325.853 24.2018 321.079 24.2018 317.996 27.0208C317.926 27.0869 317.887 27.1778 317.886 27.2729C317.885 27.3681 317.923 27.4596 317.991 27.527L319.286 28.8135C319.419 28.9449 319.635 28.9477 319.772 28.8198C320.784 27.9192 322.1 27.4202 323.464 27.4197ZM325.953 30.4901C326.023 30.4233 326.061 30.3313 326.059 30.2359C326.057 30.1405 326.015 30.0501 325.943 29.9861C324.512 28.7964 322.417 28.7964 320.986 29.9861C320.914 30.0501 320.872 30.1404 320.87 30.2358C320.868 30.3312 320.906 30.4232 320.975 30.4901L323.216 32.7129C323.281 32.7782 323.371 32.815 323.464 32.815C323.558 32.815 323.647 32.7782 323.713 32.7129L325.953 30.4901Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M288.877 28.2803H290.062C290.717 28.2803 291.248 28.7879 291.248 29.414V31.6813C291.248 32.3074 290.717 32.815 290.062 32.815H288.877C288.222 32.815 287.691 32.3074 287.691 31.6813V29.414C287.691 28.7879 288.222 28.2803 288.877 28.2803ZM294.409 26.013H295.595C296.25 26.013 296.78 26.5206 296.78 27.1467V31.6813C296.78 32.3074 296.25 32.815 295.595 32.815H294.409C293.755 32.815 293.224 32.3074 293.224 31.6813V27.1467C293.224 26.5206 293.755 26.013 294.409 26.013ZM299.942 23.3678H301.127C301.782 23.3678 302.313 23.8754 302.313 24.5015V31.6813C302.313 32.3074 301.782 32.815 301.127 32.815H299.942C299.287 32.815 298.756 32.3074 298.756 31.6813V24.5015C298.756 23.8754 299.287 23.3678 299.942 23.3678ZM305.474 20.7227H306.66C307.314 20.7227 307.845 21.2302 307.845 21.8563V31.6813C307.845 32.3074 307.314 32.815 306.66 32.815H305.474C304.819 32.815 304.289 32.3074 304.289 31.6813V21.8563C304.289 21.2302 304.819 20.7227 305.474 20.7227Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M47.44 32.7227V22.8273H47.2978L44.2949 24.9352V22.8608L47.4484 20.6525H49.5981V32.7227H47.44ZM55.9385 32.7227V22.8273H55.7963L52.7934 24.9352V22.8608L55.9469 20.6525H58.0966V32.7227H55.9385ZM63.0819 31.0581C62.2956 31.0581 61.7435 30.4893 61.7435 29.7365C61.7435 28.9753 62.2956 28.4149 63.0819 28.4149C63.8765 28.4149 64.4202 28.9753 64.4202 29.7365C64.4202 30.4893 63.8765 31.0581 63.0819 31.0581ZM63.0819 24.9519C62.2956 24.9519 61.7435 24.3915 61.7435 23.6387C61.7435 22.8775 62.2956 22.3171 63.0819 22.3171C63.8765 22.3171 64.4202 22.8775 64.4202 23.6387C64.4202 24.3915 63.8765 24.9519 63.0819 24.9519ZM71.5134 33.0238C68.6193 33.0238 66.9045 30.6817 66.9045 26.675C66.9045 22.6851 68.6444 20.3514 71.5134 20.3514C74.3741 20.3514 76.114 22.6851 76.114 26.6918C76.114 30.6817 74.3992 33.0238 71.5134 33.0238ZM71.5134 31.2338C73.0442 31.2338 73.9308 29.6696 73.9308 26.675C73.9308 23.6972 73.0274 22.1498 71.5134 22.1498C69.9994 22.1498 69.0877 23.7056 69.0877 26.675C69.0877 29.6696 69.9827 31.2338 71.5134 31.2338ZM84.0688 32.7227V30.4224H78.1717V28.624C79.7359 25.8971 81.4506 23.1452 83.0901 20.6525H86.1348V28.5989H87.7659V30.4224H86.1348V32.7227H84.0688ZM80.1708 28.532V28.6491H84.1022V22.4091H83.9851C82.7471 24.2827 81.3502 26.4994 80.1708 28.532Z"
                    fill="#ECECEE"
                  ></path>
                </svg>
                <img
                  src="@/assets/snapchatImage/spotlight-header.svg"
                  width="100%"
                  alt=""
                />
              </div>
              <div
                class="body d-flex align-center justify-space-between flex-column position-relative"
              >
                <div
                  class="data"
                  :style="
                    image_url ? { backgroundImage: `url(${image_url})` } : ''
                  "
                >
                  <div v-if="video_url" class="video-data">
                    <video muted loop id="myVideo">
                      <source :src="video_url" type="video/mp4" />
                    </video>
                  </div>

                  <div class="bottom">
                    <div class="profile-favoriting">
                      <div
                        class="spotlight-profile-standard-button d-flex flex-column align-start justify-space-between"
                      >
                        <div class="profile d-flex align-center ga-3">
                          <div class="img">
                            <img
                              width="20"
                              src="https://cf-st.sc-cdn.net/d/YmmIFdcbee3keYymYPlJq?bo=Eg0aABoAMgEESAJQCGAB&uc=8"
                              alt=""
                            />
                          </div>

                          <div class="name">
                            <span class="font-weight-bold">{{
                              brand_name
                            }}</span>
                          </div>
                        </div>
                        <div
                          class="d-flex align-center justify-space-between w-100 spotlight-details"
                        >
                          <span class="text">details</span>
                          <span class="ad">ad</span>
                        </div>
                        <div class="standard-button d-flex align-center ga-2">
                          <span
                            :class="
                              standard_button_color
                                ? 'button standard-color'
                                : ' button'
                            "
                            >{{ call_to_action }}</span
                          >
                        </div>
                      </div>
                      <div class="profile-favoriting-favoriting">
                        <div v-if="ad_favoriting" class="svg">
                          <svg
                            width="48"
                            height="48"
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="styles-5mtvke"
                          >
                            <g clip-path="url(#clip)">
                              <g filter="url(#filter-heart)">
                                <path
                                  d="M24 15.1088C32.4677 4.43472 44.9916 15.6853 37.9154 26.6395C35.7984 30.8893 29.0331 36.0287 25.347 38.6643C24.9434 38.9465 24.4766 39.0963 24 39.0963C23.5233 39.0963 23.0563 38.9465 22.6528 38.6643C18.8926 36.0287 12.2013 30.8893 10.0844 26.6395C2.99341 15.6853 15.5914 4.43472 24 15.1088Z"
                                  fill="white"
                                ></path>
                                <path
                                  d="M25.6336 39.074L25.6336 39.0741L25.6378 39.071C27.4865 37.7492 30.1156 35.7937 32.5516 33.6311C34.9651 31.4884 37.2414 29.0975 38.3504 26.8875C41.9976 21.2197 40.6125 15.4001 37.113 12.3848C35.3639 10.8776 33.0877 10.0769 30.6811 10.3706C28.4155 10.6471 26.0857 11.8866 24.0013 14.3211C21.9299 11.8866 19.6058 10.6471 17.3418 10.3706C14.9367 10.0769 12.6575 10.8776 10.904 12.3843C7.39559 15.3989 5.994 21.2187 9.6495 26.8877C10.7579 29.0965 13.0144 31.4869 15.4197 33.6305C17.847 35.7937 20.4769 37.7498 22.3658 39.0737L22.3662 39.074C22.8508 39.413 23.4173 39.5963 24 39.5963C24.5827 39.5963 25.149 39.4129 25.6336 39.074Z"
                                  stroke="black"
                                  stroke-opacity="0.05"
                                  stroke-miterlimit="10"
                                ></path>
                              </g>
                            </g>
                            <defs>
                              <filter
                                id="filter-heart"
                                x="-2"
                                y="-1.18945"
                                width="52"
                                height="52"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                ></feFlood>
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                ></feColorMatrix>
                                <feOffset></feOffset>
                                <feGaussianBlur
                                  stdDeviation="4"
                                ></feGaussianBlur>
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                ></feColorMatrix>
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_3_13290"
                                ></feBlend>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_3_13290"
                                  result="shape"
                                ></feBlend>
                              </filter>
                              <clipPath id="clip">
                                <rect
                                  width="48"
                                  height="48"
                                  fill="white"
                                  transform="translate(0 0.810547)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="svg">
                          <svg
                            class="styles-3jo2gc"
                            width="48"
                            height="48"
                            viewBox="0 0 156 156"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter-go)">
                              <path
                                d="M82.3862 39.7208L118.027 69.4408L117.987 69.4008C120.504 71.5208 121.982 74.6408 121.982 77.9608C121.982 81.2808 120.544 84.4008 117.987 86.5208L82.3862 116.201C80.9878 117.361 79.3096 117.961 77.5915 117.961C76.5127 117.961 75.4339 117.721 74.395 117.241C71.758 116.001 70.0798 113.401 70.0798 110.441V94.0408C62.0487 94.3208 50.4215 96.2008 41.3116 108.361C40.3127 109.681 38.6346 110.241 37.0363 109.801C35.4381 109.361 34.2794 108.001 34.1196 106.361C34.0396 105.561 32.2816 86.6008 44.0686 73.6008C50.3416 66.6808 59.052 62.8008 70.0798 62.0808V45.4808C70.0798 42.5208 71.718 39.9208 74.395 38.6808C77.0721 37.4408 80.1087 37.8408 82.3862 39.7208Z"
                                fill="white"
                              ></path>
                            </g>
                            <defs>
                              <filter
                                id="filter-go"
                                x="6"
                                y="12"
                                width="144"
                                height="144"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                ></feFlood>
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                ></feColorMatrix>
                                <feOffset dy="6"></feOffset>
                                <feGaussianBlur
                                  stdDeviation="12"
                                ></feGaussianBlur>
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                                ></feColorMatrix>
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_108_1540"
                                ></feBlend>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_108_1540"
                                  result="shape"
                                ></feBlend>
                              </filter>
                            </defs>
                          </svg>
                        </div>
                        <div class="svg">
                          <svg
                            class="styles-3jo2gc"
                            width="48"
                            height="48"
                            viewBox="0 0 156 156"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter-more)">
                              <path
                                d="M48 88.001C53.5228 88.001 58 83.5238 58 78.001C58 72.4781 53.5228 68.001 48 68.001C42.4771 68.001 38 72.4781 38 78.001C38 83.5238 42.4771 88.001 48 88.001Z"
                                fill="white"
                              ></path>
                              <path
                                d="M78 88.001C83.5228 88.001 88 83.5238 88 78.001C88 72.4781 83.5228 68.001 78 68.001C72.4771 68.001 68 72.4781 68 78.001C68 83.5238 72.4771 88.001 78 88.001Z"
                                fill="white"
                              ></path>
                              <path
                                d="M118 78.001C118 83.5238 113.523 88.001 108 88.001C102.477 88.001 98 83.5238 98 78.001C98 72.4781 102.477 68.001 108 68.001C113.523 68.001 118 72.4781 118 78.001Z"
                                fill="white"
                              ></path>
                            </g>
                            <defs>
                              <filter
                                id="filter-more"
                                x="6"
                                y="12"
                                width="144"
                                height="144"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                ></feFlood>
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                ></feColorMatrix>
                                <feOffset dy="6"></feOffset>
                                <feGaussianBlur
                                  stdDeviation="12"
                                ></feGaussianBlur>
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                                ></feColorMatrix>
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_101_1614"
                                ></feBlend>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_101_1614"
                                  result="shape"
                                ></feBlend>
                              </filter>
                            </defs>
                          </svg>
                        </div>
                        <div class="ad-text">ad</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" style="z-index: 1">
                <img src="@/assets/snapchatImage/1.svg" alt="" />
              </div>
              <div class="footer-data d-flex justify-center align-center">
                <div class="mobile-button"></div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <v-container
    v-if="
      selectedCampaign === 'Leads' && direct_traffic_location === 'LEAD-FORM'
    "
    style="padding: 15px 0px"
  >
    <div class="budget-and-schedule ad-set-details-card mb-6">
      <div class="d-flex align-center justify-space-between mb-5">
        <h6 class="page-header-title text-h6 mb-3">Design Your Lead Form</h6>
        <button
          @click="dialog = true"
          class="d-flex align-center justify-space-between upload-span"
        >
          <v-icon icon="mdi-plus" class="Caption"></v-icon>
          <span>Create New From</span>
        </button>
      </div>
      <v-card
        max-width="100%"
        class="pa-5 mb-5 rounded-lg budget-and-schedule-card"
        elevation="1"
      >
        <div class="">
          <v-table height="300px" class="small-text" fixed-header>
            <thead>
              <tr>
                <td></td>
                <td>Name</td>
                <td>Date</td>
                <td>CRM connection</td>
              </tr>
            </thead>
            <tbody v-if="useLeadFormStore.getting_lead_forms">
              <tr v-for="n in 5" :key="n">
                <td>
                  <input
                    name="loader"
                    id="loader"
                    type="radio"
                    style="width: 10px; height: 10px"
                  />
                </td>
                <td>
                  <v-skeleton-loader type="text"></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader type="text"></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader type="text"></v-skeleton-loader>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="lead_form in useLeadFormStore.lead_forms"
                :key="lead_form.lead_generation_form.id"
              >
                <td>
                  <input
                    @change="setLeadFormId(lead_form.lead_generation_form.id)"
                    v-model="useLeadFormStore.lead_form_id"
                    :value="lead_form.lead_generation_form.id"
                    name="placement_type"
                    :id="lead_form.id"
                    type="radio"
                  />
                </td>
                <td>
                  <div class="d-flex flex-column">
                    <span>{{ lead_form.lead_generation_form.name }}</span>
                    <div class="d-flex align-center ga-2">
                      <button
                        @click="PreviewForm(lead_form.lead_generation_form.id)"
                        class="d-flex align-center ga-1"
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="#444546"
                          xmlns="http://www.w3.org/2000/svg"
                          class="sds-icon sds-icon-eye"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.5 12C7.5 9.52 9.52 7.5 12 7.5C14.48 7.5 16.5 9.52 16.5 12C16.5 14.48 14.48 16.5 12 16.5C9.52 16.5 7.5 14.48 7.5 12ZM9.5 12C9.5 13.38 10.62 14.5 12 14.5C13.38 14.5 14.5 13.38 14.5 12C14.5 10.62 13.38 9.5 12 9.5C10.62 9.5 9.5 10.62 9.5 12Z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 3C19.61 3 22.81 11.3 22.94 11.65C23.02 11.87 23.02 12.12 22.94 12.35L22.9331 12.3674C22.7171 12.9124 19.512 21 12 21C4.39 21 1.19 12.7 1.06 12.35C0.98 12.13 0.98 11.88 1.06 11.65L1.06693 11.6326C1.2829 11.0876 4.488 3 12 3ZM3.05 12.21C3.85 13.92 6.81 19 12 19C17.18 19 20.14 13.93 20.95 12.21C21.01 12.08 21.01 11.93 20.95 11.8C20.15 10.09 17.18 5.01 12 5.01C6.82 5.01 3.86 10.08 3.05 11.8C2.99 11.93 2.99 12.08 3.05 12.21Z"
                          ></path>
                        </svg>
                        <span>Preview</span>
                      </button>
                      <button
                        @click="CloneForm(lead_form.lead_generation_form.id)"
                        class="d-flex align-center ga-1"
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 16 16"
                          fill="#444546"
                          xmlns="http://www.w3.org/2000/svg"
                          class="sds-icon sds-icon-copy"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.99999 2.66668C5.6318 2.66668 5.33333 2.96515 5.33333 3.33334V4.00001H10C11.1046 4.00001 12 4.89544 12 6.00001V10.6667H12.6667C13.0349 10.6667 13.3333 10.3682 13.3333 10V3.33334C13.3333 2.96515 13.0349 2.66668 12.6667 2.66668H5.99999ZM12 12H12.6667C13.7712 12 14.6667 11.1046 14.6667 10V3.33334C14.6667 2.22877 13.7712 1.33334 12.6667 1.33334H5.99999C4.89543 1.33334 3.99999 2.22877 3.99999 3.33334V4.00001H3.33333C2.22876 4.00001 1.33333 4.89544 1.33333 6.00001V12.6667C1.33333 13.7712 2.22876 14.6667 3.33333 14.6667H10C11.1046 14.6667 12 13.7712 12 12.6667V12ZM2.66666 6.00001C2.66666 5.63182 2.96514 5.33334 3.33333 5.33334H10C10.3682 5.33334 10.6667 5.63182 10.6667 6.00001V12.6667C10.6667 13.0349 10.3682 13.3333 10 13.3333H3.33333C2.96514 13.3333 2.66666 13.0349 2.66666 12.6667V6.00001Z"
                          ></path>
                        </svg>
                        <span>Clone</span>
                      </button>
                    </div>
                  </div>
                </td>
                <td>{{ lead_form.lead_generation_form.created_at }}</td>
                <td>{{ lead_form.lead_generation_form.crm_connection }}</td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </v-card>
    </div>
  </v-container>
  <v-container style="padding: 15px 0px">
    <div class="budget-and-schedule ad-set-details-card mb-6">
      <h6 class="page-header-title text-h6 mb-3">Delivery</h6>
      <v-card
        max-width="100%"
        class="pa-5 mb-5 rounded-lg budget-and-schedule-card"
        elevation="1"
      >
        <div class="">
          <div class="filed mt-3">
            <div class="title">delivery_status</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStatus"
                v-model:checked="delivery_status"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="filed mt-3">
              <span class="title">Impression Trackers</span>
              <div class="input-container">
                <div
                  v-for="(impression_tracker, index) in impression_trackers"
                  :key="index"
                  class="impression-trackers-template d-flex align-center ga-3"
                >
                  <input
                    type="text"
                    v-model="impression_trackers[index].value"
                    @change="impression_trackerUpdated()"
                    placeholder="Impression Tracker"
                  />
                  <span
                    class="delete-btn"
                    v-if="impression_trackers.length > 1"
                    @click="removeImpressionTracker(index)"
                    >x</span
                  >
                </div>
                <div>
                  <span class="add-another" @click="addAnotherImpressionTracker"
                    >Add Another</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="filed mt-3">
              <span class="title">Click Trackers</span>
              <div class="input-container">
                <div
                  v-for="(click_tracker, index) in click_trackers"
                  :key="index"
                  class="click-trackers-template d-flex align-center ga-3"
                >
                  <input
                    type="text"
                    v-model="click_trackers[index].value"
                    @change="click_trackersUpdated()"
                    placeholder="Click Tracker"
                  />
                  <span
                    v-if="click_trackers.length > 1"
                    class="delete-btn"
                    @click="removeClickTracker(index)"
                    >x</span
                  >
                </div>
                <div>
                  <span class="add-another" @click="addAnotherClickTracker"
                    >Add Another</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </v-container>
  <CreateLeadForm
    @update:local_dialog="dialog = $event"
    :local_dialog="dialog"
  />
  <PreviewLeadForm
    @update:local_dialog="preview_dialog = $event"
    :id="preview_id"
    :local_dialog="preview_dialog"
  />
</template>
<script>
import SwitchToogle from "../Label&input/SwitchToogle.vue";
import UploadMedia from "./uploadMedia.vue";
import CreateLeadForm from "./LeadForm/CreateLeadForm.vue";
import PreviewLeadForm from "./LeadFormPreview/PreviewLeadForm.vue";
import { useLeadFormStore } from "@/store/snapchat/LeadForm";

export default {
  components: { SwitchToogle, UploadMedia, CreateLeadForm, PreviewLeadForm },
  data: () => ({
    direct_traffic_location:
      localStorage.getItem("direct_traffic_location") || "LEAD-FORM",
    preview_id: "",
    preview_dialog: false,
    useLeadFormStore: useLeadFormStore(),
    dialog: false,
    selectedCampaign: localStorage.getItem("selectedOption") || "",
    selectedFile: null,
    ad_name: localStorage.getItem("ad_name") || "",
    brand_name: localStorage.getItem("brand_name") || "",
    headline: localStorage.getItem("headline") || "",
    offer_details_ad_disclaimer:
      localStorage.getItem("offer_details_ad_disclaimer") || "",
    offer_details_ad_disclaimer_ratio: false,
    shareable: true,
    post_to_public: false,
    image_url: localStorage.getItem("image_url") || "",
    video_url: localStorage.getItem("video_url") || "",
    single_image_or_video_tosnap_file:
      localStorage.getItem("single_image_or_video_tosnap_file") || "",
    web_view_call_to_action_items: [
      {
        title: "Apply Now",
        value: "APPLY_NOW",
      },
      {
        title: "MORE",
        value: "MORE",
      },
      {
        title: "ORDER_NOW",
        value: "ORDER_NOW",
      },
      {
        title: "PLAY",
        value: "PLAY",
      },
      {
        title: "READ",
        value: "READ",
      },
      {
        title: "SHOP_NOW",
        value: "SHOP_NOW",
      },
      {
        title: "SHOW",
        value: "SHOW",
      },
      {
        title: "SIGN_UP",
        value: "SIGN_UP",
      },
      {
        title: "VIEW",
        value: "VIEW",
      },
      {
        title: "RESPOND",
        value: "RESPOND",
      },
      {
        title: "BUY_TICKETS",
        value: "BUY_TICKETS",
      },
      {
        title: "SHOWTIMES",
        value: "SHOWTIMES",
      },
      {
        title: "BOOK_NOW",
        value: "BOOK_NOW",
      },
      {
        title: "GET_NOW",
        value: "GET_NOW",
      },
      {
        title: "LISTEN",
        value: "LISTEN",
      },
      {
        title: "TRY",
        value: "TRY",
      },
      {
        title: "VOTE",
        value: "VOTE",
      },
      {
        title: "VIEW_MENU",
        value: "VIEW_MENU",
      },
      {
        title: "PRE_REGISTER",
        value: "PRE_REGISTER",
      },
      {
        title: "PLAY_GAME",
        value: "PLAY_GAME",
      },
    ],
    leads_call_to_action_items: [
      {
        title: "APPLY NOW",
        value: "APPLY_NOW",
      },
      {
        title: "BOOK NOW",
        value: "BOOK_NOW",
      },
      {
        title: "CLAIM SAMPLE",
        value: "CLAIM_SAMPLE",
      },
      {
        title: "FREE TRIAL",
        value: "FREE_TRIAL",
      },
      {
        title: "GET COUPON",
        value: "GET_COUPON",
      },
      {
        title: "MORE",
        value: "LEARN_MORE",
      },
      {
        title: "Request Appointment",
        value: "REQUEST_APPOINTMENT",
      },
      {
        title: "Request Quote",
        value: "REQUEST_QUOTE",
      },
      {
        title: "Sign Up",
        value: "SIGN_UP",
      },
      {
        title: "Test Drive",
        value: "TEST_DRIVE",
      },
    ],
    app_install_ctas: [
      "BOOK_NOW",
      "DONATE",
      "DOWNLOAD",
      "GET_NOW",
      "INSTALL_NOW",
      "ORDER_NOW",
      "PLAY",
      "SHOP_NOW",
      "SIGN_UP",
      "TRY",
      "USE_APP",
      "WATCH",
      "VOTE",
      "DIRECTIONS",
      "PLAY_GAME",
    ],
    deep_link_ctas: [
      "DONATE",
      "PLAY",
      "SHOP_NOW",
      "SIGN_UP",
      "USE_APP",
      "MORE",
      "OPEN_APP",
      "TRY",
      "WATCH",
      "VIEW_PROFILE",
      "VOTE",
      "DIRECTIONS",
      "PRE_REGISTER",
      "PLAY_GAME",
      "DOWNLOAD",
    ],
    lead_generation_ctas: [
      "APPLY_NOW",
      "MORE",
      "BOOK_NOW",
      "GET_NOW",
      "SIGN_UP",
      "TEST_DRIVE",
      "REQUEST_APPOINTMENT",
      "REQUEST_QUOTE",
      "FREE_TRIAL",
      "CLAIM_SAMPLE",
      "GET_COUPON",
    ],
    lens_deep_link_ctas: [
      "DONATE",
      "PLAY",
      "SHOP_NOW",
      "SIGN_UP",
      "USE_APP",
      "MORE",
      "OPEN_APP",
      "TRY",
      "WATCH",
      "VIEW_PROFILE",
      "VOTE",
      "DIRECTIONS",
      "VIEW_MENU",
      "PRE_REGISTER",
      "PLAY_GAME",
    ],

    ad_to_lens_ctas: ["PLAY", "TRY", "SHOP_NOW", "VOTE"],
    ad_to_message_ctas: ["MESSAGE_NOW", "OPEN_APP"],
    ad_to_call_ctas: ["CALL_NOW", "OPEN_APP"],
    ad_to_place_ctas: ["SEE_PLACE", "DIRECTIONS", "VIEW_MENU"],

    call_to_action_items: [
      {
        title: "Apply Now",
        value: "apply_noe",
      },
      {
        title: "Book Now",
        value: "book_now",
      },
      {
        title: "Buy Now",
        value: "buy_now",
      },
      {
        title: "More",
        value: "more",
      },
    ],
    call_to_action:
      localStorage.getItem("call_to_action") ||
      localStorage.getItem("direct_traffic_location") === "LEAD-FORM"
        ? "SIGN_UP"
        : localStorage.getItem("direct_traffic_location") === "WEB"
        ? "APPLY_NOW"
        : localStorage.getItem("direct_traffic_location") === "CALL"
        ? "APPLY_NOW"
        : localStorage.getItem("direct_traffic_location") === "TEXT"
        ? "LEAD_FORM"
        : localStorage.getItem("selected_ad_type") || "None",
    ad_favoriting: true,
    standard_button_color: true,
    website_url: localStorage.getItem("website_url") || "",
    smart_prefetching: false,
    delivery_status: true,
    impression_trackers: localStorage.getItem("impression_trackers")
      ? JSON.parse(localStorage.getItem("impression_trackers"))
      : [{ value: "" }],
    click_trackers: localStorage.getItem("click_trackers")
      ? JSON.parse(localStorage.getItem("click_trackers"))
      : [{ value: "" }],
    placement_review: localStorage.getItem("placement_review") || "stories",
    current_time: new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
    selectedItem: null,
    adTypes: [
      {
        name: "None",
        value: "None",
      },
      {
        name: "Website",
        value: "WEB_VIEW",
      },
      {
        name: "App Install",
        value: "APP_INSTALL",
      },
      {
        name: "Deep Link",
        value: "DEEP_LINK",
      },
    ],
    selected_ad_type:
      localStorage.getItem("direct_traffic_location") === "LEAD-FORM"
        ? localStorage.getItem("selected_ad_type")
        : localStorage.getItem("direct_traffic_location") === "WEB"
        ? "WEB_VIEW"
        : localStorage.getItem("direct_traffic_location") === "CALL"
        ? "AD_TO_CALL"
        : localStorage.getItem("direct_traffic_location") === "TEXT"
        ? "AD_TO_MESSAGE"
        : localStorage.getItem("selected_ad_type") || "None",
    optional_text_message: localStorage.getItem("optional_text_message") || "",
    app_name: localStorage.getItem("app_name") || "",
    deep_link_uri: localStorage.getItem("deep_link_uri") || "",
    ios_app_id: localStorage.getItem("ios_app_id") || "",
    android_app_url: localStorage.getItem("android_app_url") || "",
    fallback_type: localStorage.getItem("fallback_type") || "app_install",
    custom_ios_product_page: false,
    custom_ios_product_page_id:
      localStorage.getItem("custom_ios_product_page_id") || "",
    image_app_icon_url: localStorage.getItem("image_app_icon_url") || "",
    image_app_icon_file: localStorage.getItem("image_app_icon_file") || "",
    fallback_website_url: localStorage.getItem("fallback_website_url") || "",
    user_info: localStorage.getItem("user_info") || "",
    public_profile_id:
      JSON.parse(localStorage.getItem("public_profile_id")) || "",
  }),
  methods: {
    setLeadFormId(id) {
      this.useLeadFormStore.lead_form_id = id;
      localStorage.setItem("lead_form_id", id);
    },
    PreviewForm(id) {
      this.preview_id = id;
      this.preview_dialog = true;
    },
    CloneForm(id) {
      // alert(id);
      this.useLeadFormStore.getSingleLeadForm(id);
      this.dialog = true;
    },
    getButtonStyle(type) {
      const isActive = this.fallback_type === type;
      return {
        backgroundColor: isActive ? "black" : "white",
        color: isActive ? "white" : "black",
      };
    },

    ToggleShareable() {
      this.ToggleShareable = !this.ToggleShareable;
    },
    updateImage(croppedImage) {
      this.image_url = croppedImage;
    },
    updateAppIconImage(croppedImage) {
      this.image_app_icon_url = croppedImage;
    },
    updateVideo(croppedVideo) {
      this.video_url = croppedVideo;
    },
    uploadFile(id) {
      this.single_image_or_video_tosnap_file = id;
      localStorage.setItem("single_image_or_video_tosnap_file", id);
    },
    uploadimageAppIconFile(image_app_icon_file) {
      this.image_app_icon_file = image_app_icon_file;
      localStorage.setItem("image_app_icon_file", image_app_icon_file);
    },
    TogglePostToPublicProfile() {
      this.TogglePostToPublicProfile = !this.TogglePostToPublicProfile;
    },
    ToggleAdFavoriting() {
      this.ToggleAdFavoriting = !this.ToggleAdFavoriting;
    },
    ToggleStandardButtonColor() {
      this.ToggleStandardButtonColor = !this.ToggleStandardButtonColor;
    },
    ToggleSmartPerefetching() {
      this.ToggleSmartPerefetching = !this.ToggleSmartPerefetching;
    },
    ToggleStatus() {
      this.ToggleStatus = !this.ToggleStatus;
    },
    ToggleCustomIosProductPage() {
      this.ToggleCustomIosProductPage = !this.ToggleCustomIosProductPage;
    },
    addAnotherImpressionTracker() {
      this.impression_trackers.push({ value: "" });
    },
    removeImpressionTracker(index) {
      if (this.impression_trackers.length > 1) {
        this.impression_trackers.splice(index, 1);
      }
    },
    addAnotherClickTracker() {
      this.click_trackers.push({ value: "" });
    },
    removeClickTracker(index) {
      if (this.click_trackers.length > 1) {
        this.click_trackers.splice(index, 1);
      }
    },
    playVideo(event) {
      const video = event.target.querySelector("video");
      if (video) video.play();
    },
    pauseVideo(event) {
      const video = event.target.querySelector("video");
      if (video) video.pause();
    },
    click_trackersUpdated() {
      localStorage.setItem(
        "click_trackers",
        JSON.stringify(this.click_trackers)
      );
    },
    impression_trackerUpdated() {
      localStorage.setItem(
        "impression_trackers",
        JSON.stringify(this.impression_trackers)
      );
    },
    deleteFile(file) {
      localStorage.removeItem(file);
      this[file] = "";
      if (file === "single_image_or_video_tosnap_file") {
        this.image_url = "";
        this.video_url = "";
      }
    },
  },
  watch: {
    selected_ad_type(v) {
      localStorage.setItem("selected_ad_type", v);
      if (v === "AD_TO_MESSAGE") {
        this.call_to_action = "Message Now";
      }
    },
    optional_text_message(v) {
      localStorage.setItem("optional_text_message", v);
    },

    fallback_type(v) {
      localStorage.setItem("fallback_type", v);
    },
    app_name(v) {
      localStorage.setItem("app_name", v);
    },
    deep_link_uri(v) {
      localStorage.setItem("deep_link_uri", v);
    },
    ios_app_id(v) {
      localStorage.setItem("ios_app_id", v);
    },
    android_app_url(v) {
      localStorage.setItem("android_app_url", v);
    },
    ad_name(v) {
      localStorage.setItem("ad_name", v);
    },
    brand_name(v) {
      localStorage.setItem("brand_name", v);
    },
    headline(v) {
      localStorage.setItem("headline", v);
    },
    offer_details_ad_disclaimer(v) {
      localStorage.setItem("offer_details_ad_disclaimer", v);
    },
    offer_details_ad_disclaimer_ratio(v) {
      localStorage.setItem("offer_details_ad_disclaimer_ratio", v);
    },
    shareable(v) {
      localStorage.setItem("shareable", v);
    },
    post_to_public(v) {
      localStorage.setItem("post_to_public", v);
    },
    image_url(v) {
      localStorage.setItem("image_url", v);
    },
    // single_image_or_video_tosnap_file(v) {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     const base64Data = reader.result;

    //     const fileData = {
    //       id: "single_image_or_video_tosnap_file",
    //       name: v.name,
    //       type: v.type,
    //       size: v.size,
    //       content: base64Data,
    //     };

    //     const request = indexedDB.open("FileStorage", 1);

    //     request.onupgradeneeded = (event) => {
    //       const db = event.target.result;
    //       if (!db.objectStoreNames.contains("files")) {
    //         db.createObjectStore("files", { keyPath: "id" });
    //       }
    //     };

    //     request.onsuccess = (event) => {
    //       const db = event.target.result;
    //       const transaction = db.transaction(["files"], "readwrite");
    //       const store = transaction.objectStore("files");

    //       store.put(fileData);
    //     };

    //     request.onerror = (event) => {
    //       console.error("Error saving to IndexedDB:", event.target.error);
    //     };
    //   };

    //   reader.readAsDataURL(v); // Convert the file to Base64
    // },
    // image_app_icon_file(v) {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     const base64Data = reader.result; // Base64 content of the file

    //     const fileData = {
    //       id: "image_app_icon_file", // Unique ID for the file
    //       name: v.name,
    //       type: v.type,
    //       size: v.size,
    //       content: base64Data, // Store Base64 content
    //     };

    //     // Save the file data to IndexedDB
    //     const request = indexedDB.open("FileStorage", 1);

    //     request.onupgradeneeded = (event) => {
    //       const db = event.target.result;
    //       if (!db.objectStoreNames.contains("files")) {
    //         db.createObjectStore("files", { keyPath: "id" });
    //       }
    //     };

    //     request.onsuccess = (event) => {
    //       const db = event.target.result;
    //       const transaction = db.transaction(["files"], "readwrite");
    //       const store = transaction.objectStore("files");

    //       store.put(fileData);
    //     };

    //     request.onerror = (event) => {
    //       console.error("Error saving to IndexedDB:", event.target.error);
    //     };
    //   };

    //   reader.readAsDataURL(v); // Convert the file to Base64
    // },
    call_to_action(v) {
      localStorage.setItem("call_to_action", v);
    },
    ad_favoriting(v) {
      localStorage.setItem("ad_favoriting", v);
    },
    standard_button_color(v) {
      localStorage.setItem("standard_button_color", v);
    },
    website_url(v) {
      localStorage.setItem("website_url", v);
    },
    smart_prefetching(v) {
      localStorage.setItem("smart_prefetching", v);
    },
    delivery_status(v) {
      localStorage.setItem("delivery_status", v);
    },
    placement_review(v) {
      localStorage.setItem("placement_review", v);
    },
    image_app_icon_url(v) {
      localStorage.setItem("image_app_icon_url", v);
    },
    custom_ios_product_page_id(v) {
      localStorage.setItem("custom_ios_product_page_id", v);
    },
    custom_ios_product_page(v) {
      localStorage.setItem("custom_ios_product_page", v);
    },
    fallback_website_url(v) {
      localStorage.setItem("fallback_website_url", v);
    },
  },
  computed: {
    getAdTypes() {
      if (this.selectedCampaign === "App Promotion") {
        return this.adTypes.filter(
          (adType) =>
            adType.name === "Deep Link" || adType.name === "App Install"
        );
      }
      return this.adTypes;
    },
  },
  mounted() {
    if (this.selectedCampaign === "Leads") {
      this.useLeadFormStore.getLeadForms();
      this.useLeadFormStore.lead_form_id = localStorage.getItem("lead_form_id");
    }
    this.offer_details_ad_disclaimer_ratio =
      localStorage.getItem("offer_details_ad_disclaimer_ratio") === "true";
    this.shareable = localStorage.getItem("shareable") === "true";
    this.post_to_public = localStorage.getItem("post_to_public") === "true";
    this.ad_favoriting = localStorage.getItem("ad_favoriting") === "true";
    this.standard_button_color =
      localStorage.getItem("standard_button_color") === "true";
    this.smart_prefetching =
      localStorage.getItem("smart_prefetching") === "true";
    this.delivery_status = localStorage.getItem("delivery_status") === "true";
    this.custom_ios_product_page =
      localStorage.getItem("custom_ios_product_page") === "true";

    if (!localStorage.getItem("call_to_action")) {
      const directTrafficLocation = localStorage.getItem(
        "direct_traffic_location"
      );
      let callToAction = "None";

      switch (directTrafficLocation) {
        case "LEAD-FORM":
          callToAction = "SIGN_UP";
          break;
        case "WEB":
        case "CALL":
          callToAction = "APPLY_NOW";
          break;
        case "TEXT":
          callToAction = "LEAD_FORM";
          break;
        default:
          callToAction = localStorage.getItem("selected_ad_type") || "None";
      }

      localStorage.setItem("call_to_action", callToAction);
    }
  },
};
</script>
<style scoped>
.web-site-button {
  border-radius: 0px 5px 5px 0px;
  padding: 5px 15px;
  margin: 0px;
  border: solid 0.1px black;
}
.app-install-button {
  border-radius: 5px 0px 0px 5px;
  padding: 5px 15px;
  margin: 0px;
  border: solid 0.1px black;
}
.spotlight-details {
  padding: 0px 8px;
}
.spotlight-details .text,
.spotlight-details .ad {
  font-size: 10px;
}
.spotlight-details .ad {
  background-color: rgba(226, 226, 226, 0.377);
  border-radius: 7px;
  padding: 3px 5px;
}
.spotlight-profile-standard-button {
  width: 100%;
}
.spotlight-profile-standard-button .profile {
  padding: 0px 8px;
}
.see-details {
  -webkit-box-align: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 100px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  -webkit-box-pack: center;
  justify-content: center;
  width: fit-content;
  padding: 0px 8px;
  margin: 5px 11px;
}
.see-details svg {
  height: 10px;
  width: 10px;
}
.see-details span {
  color: rgb(255, 255, 255);
  font-size: 8px;
  font-weight: 500;
  line-height: 16px;
}
.video-data {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  border-radius: 20px;
  overflow: hidden;
}
.video-data video {
  height: 100%;
  width: 100%;
}
.spotlight-review .bottom .profile-favoriting {
  align-items: end !important;
}
.bottom .profile-favoriting {
  display: flex;
  align-items: center;
  padding: 0px 8px;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 40px;
}
.bottom .profile-favoriting .svg svg,
.bottom .profile-favoriting .ad-text {
  width: 38px;
}
.bottom .profile-favoriting .profile-favoriting-data {
  background-color: rgb(109 109 109 / 26%);
  border-radius: 13px;
  width: 100%;
  padding: 10px 20px;
}
.bottom .profile-favoriting .profile-favoriting-data .profile .name {
  font-size: 12px;
}
.styles-1dxk6ak {
  height: 22px;
}
.styles-yedxbn {
  width: 31px;
  height: 100%;
}
.data-review {
  height: 695px;
  width: 320px;
  background-color: black;
  color: white;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 15px;
  overflow: hidden;
}
.data-review .header {
  padding: 0px;
}
.data-review .body {
  height: 100%;
}
.data-review .body .data {
  height: 100%;
  width: 100%;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  background-position: center;
  background-size: contain;
}
.data-review .body .data .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
}
.data-review .body .data .top .img-name {
  padding: 0px 20px;
}
.data-review .body .data .top .img-name .name {
  font-size: 12px;
  font-weight: 600;
  line-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.data-review .body .data .top .img-name .ad {
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.32);
  color: rgb(236, 236, 236);
  font-size: 12px;
  font-weight: 500;
  padding: 0px 5px;
}
.data-review .body .data .bottom {
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  z-index: 1;
}
.standard-button {
  height: 38px;
  width: 100%;
  padding: 0px 8px;
  z-index: 1;
  margin-top: 10px;
}

.standard-button .button {
  -webkit-box-align: center;
  align-items: center;
  background-color: rgb(255, 255, 255);
  border-radius: 100px;
  color: rgb(0, 0, 0);
  display: flex;
  font-size: 54px;
  font-weight: 500;
  -webkit-box-pack: center;
  justify-content: center;
  height: 40px;
  width: 100%;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 500;
}
.standard-color {
  background-color: rgb(254, 251, 0) !important;
}
.standard-button .share {
  -webkit-box-align: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.1);
  border-radius: 100px;
  display: flex;
  height: 40px;
  -webkit-box-pack: center;
  justify-content: center;
  width: 60px;
}
.share-svg {
  width: 30px;
  height: 30px;
}
.data-review .footer-data {
  z-index: 1;
}
.data-review .footer-data .mobile-button {
  margin-top: 20px;
  height: 5px;
  width: 45%;
  background-color: white;
  border-radius: 10px;
}
.add-another {
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}
.delete-btn {
  background: #fff;
  border: 1px solid #e4e2e2;
  padding: 0;
  height: 40px;
  width: 40px;
  align-items: center;
  border-radius: 50%;
  box-shadow: none;
  box-sizing: border-box;

  font-size: 14px;
  font-weight: 600;
  outline: 1px;
  padding: 10px;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.delete-btn:hover {
  background: #fff;
  border: 1px solid #f7d901;
}
.bg-white {
  background-color: white;
}
.box-shadow {
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.15);
}
input {
  background-color: #f9f9fa;
}
.warning {
  display: flex;
  gap: 5px;
}
.warning-svg {
  display: flex;
  color: rgb(8, 148, 250);
  fill: rgb(8, 148, 250);
  flex-shrink: 0;
}
.input-container {
  position: relative;
}
.input-container .options {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.name-templates {
  height: 80px;
  overflow-y: scroll;
}
.name-template-dialog-card {
  padding: 15px 20px;
}
.name-template-dialog-card .body .title {
  color: rgb(0, 0, 0);
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}
.filed .title {
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}
.profile-pic {
  border-radius: 8px;
  border: 1px solid rgb(209, 211, 213);
  padding: 16px;
  background-color: #fff;
  background-clip: padding-box;
}
.pic {
  border-style: solid;
  border-radius: 50%;
  box-sizing: border-box;
  text-align: center;
  color: rgb(68, 69, 70);
  font-weight: bold;
  background-size: cover;
  border-color: rgb(195, 197, 199);
  width: 40px;
  height: 40px;
  line-height: 36px;
  border-width: 1px;
  overflow: hidden;
}
.pic img {
  width: 100%;
  height: 100%;
}
.radio-small {
  color: rgb(84, 85, 87);
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  text-decoration: underline;
}
</style>
